<template>
  <div id="honor_all">
    <div id="comlist" class="animated fadeInLeft" :style="{ animationDuration: '3s' }">
      <ul id="honor_list">
        <li><span id="honor_En"><i class="fa fa-list fa-fw"></i>公司荣誉<br> Company Honor</span></li>
        <li><router-link to="/honors/TechnologyCertification">技术认证</router-link></li>
        <li><router-link to="/honors/ExperimentReport">实验报告</router-link></li>
      </ul>
    </div>
    <div id="honor_show">
      <div id="honor_sp">
        <div id="Honor_name" class="animated slideInRight" :style="{ animationDuration: '3s' }"><i class="fa fa-hand-o-right"></i>荣誉证书</div>
      </div>
      <router-view></router-view>
    </div>
    <div style="clear: both;"></div>
  </div>
</template>

<script setup>
import { defineComponent } from 'vue';

defineComponent({
  name: 'Honor'
});
</script>

<style scoped>
*{
    margin:0;
    padding:0;
}
#honor_all {
  height: 1600px;
  background: url("@/static/images/bg_body5.jpg") no-repeat;
}

#Honor_name {
  background: url("@/static/images/honor_bgname.jpg") no-repeat;
  background-size: 100%;
  border: 2px solid #a1a1a1;
  border-radius: 50%;
  width: 200px;
  box-shadow: 10px 10px 5px #888888;
}

#honor_list {
  width: 20%;
  height: 500px;
  float: left;
  font-size: 20px;
  font-weight: bold;
  background: rgba(226, 226, 226, 0.4);
  text-align: center;
}

#honor_list li:first-child {
  padding-top: 30px;
  background: black;
  color: #ffffff;
  font-size: 25px;
  padding-bottom: 15px;
}

#honor_list a {
  font-size: 25px;
  color: #007BFF;
  text-decoration: none;
}
 #honor_list a:hover{
    font-size: 30px;
    color:#F48D1A;
    transition-duration: 0.5s;
  }

#honor_sp {
  padding-top: 35px;
}

#honor_show {
  width: 80%;
  text-align: center;
  font-size: 20px;
  color: #007BFF;
  font-weight: bold;
  float: left;
  
}

@media (min-width: 360px) {
  #honor_list li:first-child {
    font-size: 13px;
  }

  #honor_list a {
    font-size: 13px;
  }

  #honor_all {
    height: auto;
  }
}

@media (min-width: 768px) {
  #honor_list li:first-child {
    font-size: 20px;
  }

  #honor_list a {
    font-size: 20px;
  }

  #honor_all {
    height: 1600px;
  }

  #honor_show {
    height: 1600px;
  }
}

@media (min-width: 992px) {
  #honor_list li:first-child {
    font-size: 24px;
  }

  #honor_list a {
    font-size: 24px;
  }

  #honor_all {
    height: 1000px;
  }

  #honor_show {
    height: 1000px;
  }
}

@media (min-width: 1280px) {
  #honor_list li:first-child {
    font-size: 28px;
  }

  #honor_list a {
    font-size: 28px;
  }

  #honor_all {
    height: 1000px;
  }

  #honor_show {
    height: 1000px;
  }
}

@media (min-width: 1920px) {
  #honor_list li:first-child {
    font-size: 30px;
  }

  #honor_list a {
    font-size: 30px;
  }

  #honor_all {
    height: 1500px;
  }
}
</style>